// src/app/not-found.tsx
"use client";

import Link from "next/link";
import dynamic from "next/dynamic";
import styles from "./not-found.module.css";

// Lazy load Robot404 vì nó sử dụng three.js (heavy bundle)
const Robot404 = dynamic(() => import("./(site)/components/Robot404"), {
  loading: () => <div className={styles.robotPlaceholder}>Đang tải...</div>,
  ssr: false,
});

export default function NotFound() {
  return (
    <main className={styles.container}>
      <section className={styles.card}>
        {/* Bên trái: nội dung */}
        <div className={styles.left}>
          <h1 className={styles.title}>404 — Không tìm thấy trang</h1>
          <p className={styles.description}>
            Ủa alo? Trang này đi đâu mất rồi... Có lẽ nó đang trốn sau lưng robot đấy!
          </p>
          <div className={styles.actions}>
            <Link href="/" className={styles.primary}>
              Về trang chủ nào
            </Link>
          </div>
        </div>

        {/* Bên phải: Robot 3D siêu đẹp */}
        <div className={styles.right}>
          <Robot404 />
        </div>
      </section>
    </main>
  );
}